import React from "react";
import { Modal, Button } from "react-bootstrap";

/**
 * @param {Object} props
 * @param {React.ReactNode} props.title
 * @param {boolean} props.show
 * @param {() => void} props.onOk
 * @param {() => void} props.onCancel
 * @param {string} [props.okText] defaults to `Yes`
 * @param {string} [props.okVariant] defaults to `danger`
 * @param {string} [props.cancelText] defaults to `No`
 */
const Popconfirm = ({
  title,
  show,
  onOk,
  onCancel,
  okText = "Yes",
  okVariant = "danger",
  cancelText = "No",
}) => (
  <Modal size="sm" show={show} onHide={onCancel} contentClassName="border-1">
    <Modal.Header closeButton />
    <Modal.Body className="text-center m-3 p-4">
      <h3>{title}</h3>
    </Modal.Body>
    <Modal.Footer className="d-flex justify-content-center">
      <Button variant="info" onClick={onCancel}>
        {cancelText}
      </Button>
      <Button variant={okVariant} onClick={onOk}>
        {okText}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default Popconfirm;
